import { render, staticRenderFns } from "./changeColor.vue?vue&type=template&id=85a582b8&scoped=true&"
import script from "./changeColor.vue?vue&type=script&lang=js&"
export * from "./changeColor.vue?vue&type=script&lang=js&"
import style0 from "./changeColor.vue?vue&type=style&index=0&id=85a582b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a582b8",
  null
  
)

export default component.exports